import { ReactComponent as IconChevronDown } from '@/assets/svgs/chevron-down.svg'
import { ReactComponent as IconPin } from '@/assets/svgs/package.svg'
import useEclips from '@/hooks/use-eclips/index'
import usePaginating from '@/hooks/use-paginating/index'
import { useEffect, useState } from 'react'
import usePackages from '@/hooks/use-packages/index.js'

export default function PackagesList({
	dataElementId,
	selected,
	search,
	visible,
	handlePackageSelection,
	version
}) {
	const [receivedPackageItems, setReceivedPackageItems] = useState([])
	const [receivedMeta, setReceivedMeta] = useState({})

	const {
		loading,
		setReceivedEclips,
		receivedEclips,
		receivedEclipsMeta,
		getReceivedEclips,
	} = useEclips()

	const {
		getReceivedPackages,
		receivedPackages,
		receivedPackagesMeta,
	} = usePackages()

	const {
		itemsPerPage,
		currentPage,
		goToPrev,
		goToNext,
		handleCurrnetInput,
		pageLabel,
	} = usePaginating(
		5,
		receivedMeta?.total || 0,
		receivedMeta?.totalPages || 0,
	)

	useEffect(() => {
		if (visible && version !== 'v2') {
			getReceivedEclips(dataElementId, {
				limit: itemsPerPage,
				page: currentPage,
				search,
			})
			handlePackageSelection('')
		}

		if (visible && version === 'v2') {
			getReceivedPackages(dataElementId, {
				limit: itemsPerPage,
				page: currentPage,
				search,
			})
			handlePackageSelection('')
		}
	}, [search, visible, currentPage, itemsPerPage])

	useEffect(()=>{
		if(version === 'v2'){
			setReceivedPackageItems(receivedPackages)
			setReceivedMeta(receivedPackagesMeta)
		}

		if(version !== 'v2'){
			setReceivedPackageItems(receivedEclips)
			setReceivedMeta(receivedEclipsMeta)
		}

	},[receivedEclips,receivedPackages])


	return (
		<div className="package-list">
			<span className="data-element__import-list-title">Select Package</span>
			<div className="data-element__import-list">
				{receivedPackageItems?.length > 0 ? (
				receivedPackageItems?.map((item, index) => (
					<div
						className={`data-element__import-list-item tooltip ${
							item?.messageStoreId === selected ? 'selected' : ''
						}`}
						key={`att-${index}`}
						onClick={() => {
							handlePackageSelection(item?.messageStoreId)
						}}
					>
						<div className={'data-element__import-list-item-icon'}>
							<IconPin />
						</div>
						<span className="data-element__import-list-item__package-name trim">
							{item?.eclipName}
						</span>
						<span className="tooltiptext">{item.eclipName}</span>
						<span className="data-element__import-list-item__reference-number trim">
							{item?.eclipReferenceNumber || '-'}
						</span>
					</div>
				))
				) : (
				<div className="data-element__import-empty">No data</div>
				)}
			</div>
			<div className="data-table__table__footer__row">
				<div className="data-table__table__footer__row__left">
					<div className="data-table__table__pagination">
						<input
							className="data-table__table__pagination__page"
							type="number"
							value={currentPage}
							onChange={(e) => handleCurrnetInput(e)}
							min="1"
							max={receivedMeta?.totalPages}
						/>
						<span className="data-table__table__pagination__page__meta">
						{' '}
						of {receivedMeta?.totalPages || 1} pages{' '}
						</span>
						<button
							className="data-table__table__pagination__prev"
							onClick={() => goToPrev()}
							disabled={currentPage === 1 || !receivedMeta?.totalPages}
						>
							<IconChevronDown />
						</button>
						<button
							className="data-table__table__pagination__next"
							onClick={() => goToNext()}
							disabled={currentPage === receivedMeta?.totalPages || !receivedMeta?.totalPages}
						>
							<IconChevronDown />
						</button>
					</div>
				</div>
				<div className="data-table__table__footer__row__right">
					<div className="data-table__table__meta">
						Showing {pageLabel} of {receivedMeta?.total || 0} entries
					</div>
				</div>
			</div>
		</div>
	)
}
